import { Icon } from '@rbilabs/universal-components';
import { Pressable, StyleSheet, View } from 'react-native';
import { Typography } from 'ucl';

import PointsIcon from 'components/icons/loyalty-points-icon';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

interface IEarnCrownsBadge {
  bonusPoints?: number;
  isCollapsed?: boolean;
  isFirstTier?: boolean;
  isTierCompleted?: boolean;
  onToggle?: () => void;
}

export const EarnCrownsBadge = ({
  bonusPoints,
  isFirstTier,
  isCollapsed,
  isTierCompleted = false,
  onToggle,
}: IEarnCrownsBadge) => {
  if (!bonusPoints) {
    return null;
  }

  const label = isFirstTier
    ? t('bonusCrowns', {
        defaultValue: '{points} Bonus Crowns',
        points: bonusPoints.toString(),
      })
    : t('extraBonusCrowns', {
        defaultValue: '{points} Extra Bonus Crowns',
        points: bonusPoints.toString(),
      });

  const earnedLabel = t('questTierEarned', { defaultValue: 'Earned' });

  return (
    <Pressable onPress={onToggle} style={styles.row}>
      <View style={styles.labelContainer}>
        <PointsIcon size={'6'} fill={primitive.$meltyYellow} />
        <Typography variant="headerThree" style={styles.labelText}>
          {label}
        </Typography>
        {isTierCompleted && (
          <View
            style={styles.earnedBadge}
            accessible
            accessibilityRole="text"
            accessibilityLabel={earnedLabel}
          >
            <Typography
              variant="copyTwo"
              fontSize="2xs"
              color={primitive.$bbqBrown}
              style={styles.earnedBadgeText}
            >
              {earnedLabel}
            </Typography>
          </View>
        )}
      </View>
      {onToggle != null && (
        <Icon variant={isCollapsed ? 'select' : 'collapse'} size="7" color={primitive.$bbqBrown} />
      )}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.$1,
  },
  labelText: {
    marginBottom: 0,
  },
  // Mirrors Figma node 21954:19574 — small success pill rendered when the
  // tier is completed. Background uses the closest existing primitive token
  // ($successLight #D5F7D4) to Figma's #D4F7DE; text uses $bbqBrown (#502314).
  earnedBadge: {
    paddingHorizontal: 4,
    paddingVertical: 2,
    borderRadius: 4,
    backgroundColor: primitive.$successLight,
  },
  earnedBadgeText: {
    marginBottom: 0,
    lineHeight: 15,
  },
});
